<template>
  <div class="Slider" @mouseover="preloadImg(imageLs)">
  <!-- <div class="Slider"> -->
    <div :id="id" class="Slider-wrapper Intrinsic-wrapper" :class="classes">

      <transition :name="transitionName" mode="in-out">
        <img
          class="Slider-wrapper-img Intrinsic-item lazyload"
          v-for="(img, i) in imageLs[0]"
          :key="i"
          v-if="currentImageIndex === i"
          :data-src="'./static/images/' + img.fileName"
          :alt="img.caption"
          @click="imgHandler">
      </transition>

      <transition name="fade" mode="out-in">
      <footer
        class="Slider-footer"
        v-for="(img, i) in imageLs[0]"
        v-if="currentImageIndex === i && img.caption !== ''"
        :key="'img-' + i">
        <p class="Slider-footer-body">
          {{ img.caption }}
        </p>
      </footer>
      </transition>

    </div>
    <div>
      <ul class="Slider-map">
        <li
          class="Slider-map-dot"
          v-for="(image, i) in imageLs[0]" 
          :key="'image-' + i"
          :class="{ 'is-active': currentImageIndex === i }"
          @click="currentImageIndex = i">
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import KeyMixin from './../mixins/key'
import Hammer from 'hammerjs'
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    imageLs: {
      type: Array,
      required: true
    },
    classes: {
      type: Array,
      required: false
    }
  },

  data () {
    return {
      currentImageIndex: 0,
      transitionName: 'slide-right--fade'
    }
  },

  mixins: [ KeyMixin ],

  methods: {
    imgHandler (e) {
      const imgWidth = e.target.clientWidth
      if (e.offsetX < imgWidth / 2) {
        this.prevImage()
      } else if (e.offsetX >= imgWidth / 2) {
        this.nextImage()
      }
    },

    preloadImg (imageLs) {
      imageLs[0].forEach(imgObj => {
        let img = new Image()
        img.src = './static/images/' + imgObj.fileName
      })
    },

    nextImage () {
      this.transitionName = 'slide-left--fade'
      if (this.currentImageIndex >= this.imageLs[0].length - 1) {
        this.currentImageIndex = 0
      } else {
        this.currentImageIndex += 1
      }
    },

    prevImage () {
      this.transitionName = 'slide-right--fade'
      if (this.currentImageIndex <= 0) {
        this.currentImageIndex = this.imageLs[0].length - 1
      } else {
        this.currentImageIndex -= 1
      }
    },

    swipeController (id) {
      const slider = document.getElementById(id)
      const mc = new Hammer.Manager(slider)
      const swipe = new Hammer.Swipe()
      mc.add(swipe, {
        touchAction: 'pan-y'
      })
      mc.on('swipeleft', () => {
        this.nextImage()
      })
      mc.on('swiperight', () => {
        this.prevImage()
      })
    }
  },

  mounted () {
    this.swipeController(this.id)
    // this.preloadImg(this.imageLs)
  }
}
</script>

<style lang="scss" scoped>
@import './../assets/_variables.scss';

.Slider-footer {
  background-color: $colorTransparentPlum;
  color: $colorWhite;
  padding: 1em;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;
}

.Slider-footer-body {
  letter-spacing: .5px;
  margin: 0;
}

.Slider-map {
  display: flex;
  justify-content: center;
  list-style-type: none;
  margin: 1em 0 0 0;
  padding: 0;
}

.Slider-map-dot {
  background: transparent;
  border: 1px solid $colorPlum;
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
  margin-right: 1em;
  transition: $transitionPrimary;
  width: 12px;
  height: 12px;
  &.is-active {
    background-color: $colorPlum;
  }
  &:last-child {
    margin: 0;
  }
}

@media screen and (hover: hover) {
  .Slider-map-dot {
    &:hover {
      background-color: $colorEmerald;
    }
  }
}

.Slider-wrapper {
  cursor: pointer;
  overflow: hidden;
  &:hover::after {
    opacity: 1;
  }
  &:hover::before {
    opacity: 1;
  }
  &::after {
    background-color: transparent;
    background-image: url('./../../static/images/arrow-left.png');
    background-position: center;
    background-repeat: no-repeat;
    content: '';
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    transition: $transitionPrimary;
    width: 15%;
    height: 100%;
  }
  &::before {
    background-color: transparent;
    background-image: url('./../../static/images/arrow-right.png');
    background-position: center;
    background-repeat: no-repeat;
    content: '';
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    right: 0;
    transition: $transitionPrimary;
    width: 15%;
    height: 100%;
    z-index: 1;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Slider.vue